module.exports = __webpack_public_path__ + "media/components/breakheader/background/background--4-0f61c007e3d12adc30ed9c0699564515.jpg";